/* eslint-disable */
import validator from 'validator';

import store from '../store';

export function colorIsLight(color){
  // Variables for red, green, blue values
  var r, g, b, p;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  // HSP (P is Percieved Brightness) equation from http://alienryderflex.com/hsp.html
  p = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  return p > 127.5;
}

// legacy function - use the above directly if possible
export const lightOrDark = (color) => {
  return colorIsLight(color) ? 'light' : 'dark';
};

export const validateEmail = (email) => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validateURL = (url) => {
  var re = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
  return re.test(String(url));
};


export const convertStringToTimestampObj = (timestamp) => {
  let startDate = new Date(timestamp);
  let startSecs = startDate.getTime() / 1000;
  return {
    seconds: startSecs
  };
};

export const timeSince = (time, reverse) => {
  //if reverse = true, calc time until
  let date;
  if (time && time.seconds) {
    let convertSecsToDate = new Date(null);
    convertSecsToDate.setTime(time.seconds * 1000);
    date = convertSecsToDate;
  } else {
    date = time;
  }
  var seconds = Math.floor((new Date() - date) / 1000);
  if (reverse) {
    seconds = Math.floor((date - new Date()) / 1000);
  }

  var interval = Math.floor(seconds / 31536000);

  if(!interval && !seconds) return '0 secs'
  if (interval > 0) {
    return interval + ` ${interval === 1 ? 'year' : 'years'}`;
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 0) {
    return interval + ` ${interval === 1 ? 'month' : 'months'}`;
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 0) {
    return interval + ` ${interval === 1 ? 'day' : 'days'}`;
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 0) {
    return interval + ` ${interval === 1 ? 'hr' : 'hrs'}`;
  }
  interval = Math.floor(seconds / 60);
  if (interval > 0) {
    return interval + ` ${interval === 1 ? 'min' : 'mins'}`;
  }
  return Math.floor(seconds) + ` ${seconds <= 1 ? 'sec' : 'secs'}`;
};

export const timeSinceMin = (time, reverse) => {
  //if reverse = true, calc time until
  let date;
  if (time) {
    let convertSecsToDate = new Date(null);
    let isoToTimeNo = Date.parse(time)
    convertSecsToDate.setTime(isoToTimeNo);
    date = convertSecsToDate;
  }
  else {
    console.warn("please provide time to timeSinceMin");
    return '';
  }

  var seconds = Math.floor((new Date() - date) / 1000);
  if (reverse) {
    seconds = Math.floor((date - new Date()) / 1000);
  }

  var interval = Math.floor(seconds / 31536000);

  if (interval > 0) {
    return interval + 'y';
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 0) {
    return interval + 'mo';
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 0) {
    return interval + 'd';
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 0) {
    return interval + 'h';
  }
  interval = Math.floor(seconds / 60);
  if (interval > 0) {
    return interval + 'm';
  }
  return Math.floor(seconds) + 's';
};

const sortArrayOfObjects = (data) => {
  let { key, order = 'asc' } = data;

  return function innerSort(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === 'desc' ? comparison * -1 : comparison;
  };
};

export const mapToRange = (num, in_min, in_max, out_min, out_max) => {
  return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
};

export const clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a));

export const mapToRangeClamped = (num, in_min, in_max, out_min, out_max) => {
  return clamp(((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min, out_min, out_max);
};

export const generateRandomID = (prefix) => {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  if (prefix) {
    return '_' + prefix + Math.random().toString(36).substr(2, 9);
  } else {
    return Math.random().toString(36).substr(2, 9);
  }
};

export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
}

export const getRandomFloat = (min, max) => {
  return Math.random() * (max - min) + min;
}


export const hexToRGB = (h) => {
  let r = 0, g = 0, b = 0;

  // 3 digits
  if (h.length == 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

  // 6 digits
  } else if (h.length == 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  return "rgb("+ +r + "," + +g + "," + +b + ")";
}

export function arrayToObject(array, getKey){
  let rtn = {};
  for(let i = 0; i < array.length; i++) rtn[getKey(array[i], i)] = array[i];
  return rtn;
}

// 86400000 ms in a day
export const daysSinceEpoch = date => date.valueOf()/86400000;
export const daysSinceNow = date => daysSinceEpoch(new Date()) - daysSinceEpoch(date);

export function displayHappenedAtDate(date){
	const now = new Date();
	const daysSinceHappening = daysSinceNow(date);

	let rtn = date.toLocaleTimeString('en-US', {timeStyle:"short" , hour12: true}).toUpperCase();

	if(daysSinceHappening < 6 && daysSinceHappening > 0.5){
		return rtn+', '+date.toLocaleDateString('en-US', {weekday: 'long'});
	}
	else if(daysSinceHappening >= 6) {
		return rtn = date.toLocaleDateString('en-US', {
			day: 'numeric',
			month: 'long',
			year: now.getFullYear() > date.getFullYear() ? 'numeric' : undefined
		});
	}

	return rtn;
}

export function matchAny(value, items){
  for(let i of items) if(i === value) return true;
  return false;
}

export function promiseTime(time){
  return new Promise(resolve => setTimeout(resolve, time));
}

export function processMediaURL(url){
  // missing or fully qualified URL
  if(url === null || url === '' || /^https?:\/\//.test(url)) return url;
  // media service URL
  else if(/^i\//.test(url)) return store.getters['api/media/origin'] + '/' + url;
  else {
    console.warn('unknown URL format: '+url);
    return url;
  }
}

export function convertToJPG(file){
  return new Promise(resolve => {
    var img = new Image();
    img.src = URL.createObjectURL(file);

    img.addEventListener('load', () => {
      // revoking URL for memory reasons
      URL.revokeObjectURL(img.src);

      // creating a canvas for image manipulation
      let canvas = document.createElement("canvas"), ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      // clearing the canvas
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, img.width, img.height);
      ctx.drawImage(img, 0, 0);

      canvas.toBlob(
        blob => resolve(new File([blob], "avatar.jpg", {type: "application/octet-stream"}) ),
        "image/jpeg",
        0.95
      );
    });
  });
}

export const normalizeString = input => input.toLowerCase().trim().normalize('NFD');

export function partialWordMatch(input, query){
  let inputArray = normalizeString(input).split(' '),
      queryArray = normalizeString(query).split(' ');

  for(let i of inputArray) for(let q of queryArray) if(i.includes(q)) return true;

  return false;
}

export const initaliseAreaName = name => name.split(' ').filter(s => s).map((s,i) => i < 4 ? s[0] : '').join('');

export const parseLocalStorage = (key) => {
  let value = localStorage.getItem(key);
  if (!value) return undefined
  else return JSON.parse(value)
}

export const checkIfGuid = (guid) => {
  return validator.isUUID(guid)
}
